import Vue from 'vue'
import Router from 'vue-router'
import Auth from './views/Auth'
import FirstStep from './views/FirstStep'
import Points from './views/Points'
import NotFound from './views/NotFound'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'firstStep',
      component: FirstStep,
      meta: {'auth': true}
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth,
      meta: {'auth': false}
    },
    {
      path: '/points/:routeId',
      name: 'points',
      component: Points,
      meta: {'auth': true}
    },
    {
      path: '/not-found',
      name: 'notFound',
      component: NotFound
    },
    {
      path: '*',
      redirect: {'name': 'notFound'}
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth) && !Vue.auth.check()) {
    next({
      name: 'auth',
      params: {nextUrl: to.fullPath}
    })
  } else {
    next()
  }
})

export default router
